<template>
  <svg
    @click="$emit('click', $event)"
    width="16"
    height="16"
    viewBox="0 0 50 50"
    preserveAspectRatio="xMidYMid meet"
  >
    <path
      v-if="!open"
      d="M50,12.5v5.36H0V12.5ZM0,37.5H50V32.14H0Z"
      :fill="fill"
    />
    <polygon
      v-if="open"
      points="50 4.84 45.16 0 25 20.16 4.84 0 0 4.84 20.16 25 0 45.16 4.84 50 25 29.84 45.16 50 50 45.16 29.84 25 50 4.84"
      :fill="fill"
    />
  </svg>
</template>

<script>
import { colors } from "@utils/tailwind";

export default {
  name: "CoreBurger",

  props: {
    open: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: "brown"
    }
  },

  computed: {
    fill() {
      return colors[this.color];
    }
  }
};
</script>
